import {gql} from '@apollo/client';

export const GET_DSP_HOME_PENDING_SUMMARY = gql`
    query GetDspHomePendingSummary($warehouseId: Long!) {
        getDspHomePendingSummary(warehouseId: $warehouseId) {
            pendingIssueParcelCount
            pendingPodAbnormalCount
        }
    }
`;

export interface DspHomePendingSummary {
    pendingIssueParcelCount: number;
    pendingPodAbnormalCount: number;
}

export interface GetDspHomePendingSummaryResponse {
    getDspHomePendingSummary: DspHomePendingSummary;
}

export interface GetDspHomePendingSummaryVariables {
    warehouseId: number;
}
